import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import "./BaseModal.scss";

const BaseModal = ({ title, children, close }) => {
  useEffect(() => {
    let body = document.body;
    body.style.overflowY = "hidden";
    return () => {
      body.style.overflowY = "auto";
    };
  }, []);
  return (
    <div className="baseModalWrapper">
      <div className="modalContent">
        <div className="modalHeader">
          <p className="modalTitle">{title}</p>
          <FaTimes
            className="closeIcon"
            onClick={() => {
              close();
            }}
          />
        </div>
        <div className="modalBody">{children}</div>
      </div>
      <div
        className="modalLayer"
        onClick={() => {
          close();
        }}
      ></div>
    </div>
  );
};

export default React.memo(BaseModal);
